import { Dialog } from '@datacamp/waffles/dialog';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useDispatch } from '../../interfaces/State';
import { showModal } from '../../redux/actions';
import { MODAL_TYPE } from '../../redux/selectors';

type Props = {
  exerciseType?: string;
};
const GuidesBackButton: React.FC<Props> = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const onClick = useCallback(
    () => dispatch(showModal({ modal: MODAL_TYPE.GUIDES })),
    [dispatch],
  );

  return (
    <Dialog.Button
      variant="secondary"
      data-cy="guides-back-button"
      onClick={onClick}
    >
      {t('back')}
    </Dialog.Button>
  );
};

export default GuidesBackButton;
